import { getSidebarProjectThreadsQueryOptions } from '#pplx/frontend/apps/ask/hooks/collections-hooks/collectionThreadsQueryOptions.js';
import { getPinnedFirstSpaceThreads, SPACE_THREAD_LIMIT, } from '#pplx/frontend/apps/ask/layout/sidebar/core/lite/SpaceItemsSharedSupport.js';
import { getSpacePinnedThreadsQueryKey } from '#pplx/frontend/apps/ask/queries/query-keys/spacesKeys.js';
import { listSpacePinnedThreads } from '#pplx/frontend/apps/ask/queries/spaces-queries/listSpacePinnedThreads.js';
import { EMPTY_ARRAY } from '#pplx/frontend/common/defaults.js';
import { useQueryClientAccess } from '#pplx/frontend/react-query/useQueryClientAccess.js';
import { useQueries } from '@tanstack/react-query';
export function getProjectPinnedThreadsQueryOptions(spaceUuid) {
    return {
        queryKey: getSpacePinnedThreadsQueryKey({ spaceUuid, limit: SPACE_THREAD_LIMIT }),
        queryFn: () => listSpacePinnedThreads({
            spaceUuid,
            limit: SPACE_THREAD_LIMIT,
            reason: 'sidebar-promoted-space-pinned-threads',
            throwOnError: true,
        }),
    };
}
export function useMultiProjectThreads(projects) {
    const { queryClient, queryOptions } = useQueryClientAccess();
    const pinnedQueries = useQueries({
        queries: projects.map(({ spaceUuid }) => queryOptions({
            ...getProjectPinnedThreadsQueryOptions(spaceUuid),
            enabled: Boolean(spaceUuid),
        })),
    }, queryClient);
    return useQueries({
        queries: projects.map(({ spaceSlug }, index) => {
            const pinned = pinnedQueries[index];
            return queryOptions({
                ...getSidebarProjectThreadsQueryOptions({
                    collectionSlug: spaceSlug,
                    limit: SPACE_THREAD_LIMIT,
                }),
                enabled: Boolean(spaceSlug &&
                    pinned &&
                    !pinned.isLoading &&
                    !pinned.isError &&
                    (pinned.data ?? EMPTY_ARRAY).length < SPACE_THREAD_LIMIT),
            });
        }),
        combine: (recentQueries) => projects.map(({ spaceUuid }, index) => {
            const pinned = pinnedQueries[index];
            const recent = recentQueries[index];
            const threads = getPinnedFirstSpaceThreads({
                pinnedThreads: pinned?.data ?? EMPTY_ARRAY,
                recentThreads: recent?.data ?? EMPTY_ARRAY,
            });
            return {
                spaceUuid,
                threads,
                isLoading: !pinned || !recent || pinned.isLoading || recent.isLoading,
                isError: Boolean(pinned?.isError || recent?.isError) && threads.length === 0,
            };
        }),
    }, queryClient);
}
//# sourceMappingURL=useMultiProjectThreads.js.map